import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";


// ✅ Replace with your actual Firebase credentials
const firebaseConfig = {
    apiKey: "AIzaSyBi0dE7Wuap0cgX4f2cdo4BrLbQV-x8a5w",
    authDomain: "softtelrg-6e909.firebaseapp.com",
    projectId: "softtelrg-6e909",
    storageBucket: "softtelrg-6e909.firebasestorage.app",
    messagingSenderId: "394718727154",
    appId: "1:394718727154:web:fb6a0014e12490bc86b96b",
    measurementId: "G-2ZEMT3G782"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
